import { categoryDetailLinkListStyles } from "@insite/content-library/Widgets/Category/CategoryDetailLinkList";
import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { productInformationStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// FilterAccordionSection
productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        &:not(:last-child) {
            padding-bottom: 5px;
        }
        & > ${TypographyStyle as any} {
            padding: 0;
            &:first-child {
                margin-bottom: 2px;
            }
            &:last-child {
                margin-top: 2px;
            }
        }
    `,
};

// ListCardList
listStyles.wrapper = {
    css: css`
        margin-top: 10px;
        border-top: 1px solid ${getColor("common.border")};
    `,
};

// SearchWithin
searchWithinStyles.titleText = {
    variant: "h6",
    css: css`
        margin-bottom: 5px;
    `,
};

// FilterList
filterListStyles.filterTag = {
    css: css`
        width: 100%;
    `,
};

// Product Image
productImageStyles.productImage = {
    linkWrappingImage: {
        css: css`
            justify-content: center;
            min-height: 175px;
        `,
    },
    img: {
        css: css`
            width: auto;
            max-width: 100%;
            height: auto;
            max-height: 165px;
        `,
    },
};

// Product Information
productInformationStyles.attributes = {
    container: {
        css: css`
            border-top: 1px solid #cccccc;
        `,
    },
    attributeTypeGridItem: {
        width: [5, 5, 5, 5, 5],
    },
    attributeValueGridItem: {
        width: [5, 5, 5, 5, 5],
    },
};

// CategoryDetailLinkList
categoryDetailLinkListStyles.container = {
    gap: 0,
    css: css`
        border-radius: 10px;
        border: 1px solid ${getColor("primary")};
        padding: 10px;
        padding-bottom: 10px;
        margin-bottom: 20px;
    `,
};

categoryDetailLinkListStyles.subCategoryNameLinkItem = {
    width: 12,
    css: css`
        padding-bottom: 2px;
    `,
};
